<template>
    <ValidationObserver tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
        <Loading />
        <Message />

        <CForm method="post" @submit.prevent="handleSubmit(submit)">
            <CRow>
                <CCustomInput
                    col="12" sm="6"
                    vid="bank_name"
                    :name="$t('user.bank_name')"
                    v-model="user.bank_name"
                    required
                    rules="required"
                />

                <CCustomInput
                    col="12" sm="6"
                    vid="account_owner_name"
                    :name="$t('user.account_owner_name')"
                    v-model="user.account_owner_name"
                    required
                    rules="required"
                />

                <CCustomInput
                    col="12" sm="6"
                    vid="account_number"
                    :name="$t('user.account_number')"
                    ltr
                    v-model="user.account_number"
                    required
                    rules="required"
                />

                <CCustomInput
                    col="12" sm="6"
                    vid="card_number"
                    :name="$t('user.card_number')"
                    ltr
                    v-model="user.card_number"
                    required
                    rules="required"
                />

                <CCustomInput
                    sm="12"
                    vid="sheba_number"
                    :name="$t('user.sheba_number')"
                    ltr
                    type="text"
                    rules="required|numeric|max:24"
                    v-model="user.sheba_number"
                    required
                >
                    <template #append-content>
                        IR
                    </template>
                </CCustomInput>

                <slot name="submitBtn" v-bind:invalid="invalid">
                    <CCol col="12" class="b-t-1 pt-2 mt-3">
                        <CButton :disabled="invalid" type="submit"  color="primary" class="px-4 mr-auto d-block">{{ $t('btn.submit') }}</CButton>
                    </CCol>
                </slot>
            </CRow>
        </CForm>
    </ValidationObserver>
</template>

<script>
export default {
    name: 'FinancialInformationForm',

    props: {
        user: {
            required: true,
        },
        submit: {
            default: function() {},
            required: true,
        },
    },
}
</script>